import DateAndOrTimePickerViewModelBase from '@/ViewModels/Controls/DateAndOrTimePickerViewModelBase';
import ComponentManager from '@/Management/ComponentManager';
import { extractTimeFromDate, toDotNetDateTimeString } from '@/Utility/DateHelper';
import ResourceManager from '@/Management/ResourceManager';

export default class TimePickerViewModel extends DateAndOrTimePickerViewModelBase {

    /**
     * Die minimal auswählbare Zeit im TimePicker
     */
    public min: KnockoutObservable<string>;

    /**
     * Die maximal auswählbare Zeit im TimePicker
     */
    public max: KnockoutObservable<string>;
    
    public constructor(params: any) {
        super(params);

        this.min = this.observableOrDefault(params.min, '00:00');
        this.max = this.observableOrDefault(params.max, '23:59');
    }

    /**
     * @override
     * @inheritdoc 
     * @param date 
     */
    protected parseToDotNetString(date: string): string {
        if (!date) return '';

        const [hours, minutes] = date.split(":").map(Number);
        const specificDate = new Date();
        specificDate.setHours(hours, minutes, 0, 0);

        return toDotNetDateTimeString(specificDate);
    }

    protected parseToHtmlDateTimeString(date: string | Date): string {
        return date ? extractTimeFromDate(date) : '';
    }

    public customValidate(value: string, isNullableType: boolean): boolean {
        const time = extractTimeFromDate(value);

        if (!time) return isNullableType;

        const max = this.max();
        const min = this.min();

        return time >= min && time <= max;
    }

    /**
     * @override
     * @inheritdoc 
     */
    public createPlaceHolder(): KnockoutComputed<string> {
        return this.defineComputed(() => {
            const language = ResourceManager.getInstance().getLanguage();
            return language.timePattern;
        });
    }
}

ComponentManager.setViewModel('TimePickerViewModel', TimePickerViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');